'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _HeadingConstants = require('../text/HeadingConstants');

var _AbstractElement = require('../elements/AbstractElement');

var _AbstractElement2 = _interopRequireDefault(_AbstractElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var USES = (0, _reactUtils.keyMirror)({
  condensed: null
});

// 100% arbitrary cutoff for widthConstrained mode
var CONSTRAINED_TITLE_WIDTH = 544;

var renderTitle = function renderTitle(title, badge) {
  if (!badge) return title;

  var badgeOutput = (0, _react.cloneElement)(badge, {
    className: (0, _reactUtils.classNames)(badge.props.className, 'private-header__badge')
  });

  return _react2.default.createElement(
    'span',
    { className: 'private-header__title__inner' },
    title,
    badgeOutput
  );
};

var renderHeading = function renderHeading(badge, headingLevel, title, titleBadge, titleControls) {
  var headerContentNextToTitle = titleControls || titleBadge;
  var titleControlsWrapper = headerContentNextToTitle ? _react2.default.createElement(
    'div',
    { className: 'private-header__title-badge' },
    headerContentNextToTitle
  ) : null;

  var titleWrapperClassName = (0, _reactUtils.classNames)('private-header__title', {
    'private-page__title': headingLevel === 'h1'
  });

  return _react2.default.createElement(
    'div',
    { className: titleWrapperClassName },
    _react2.default.createElement(
      _AbstractElement2.default,
      {
        className: 'private-header__heading',
        tagName: headingLevel
      },
      renderTitle(title, badge)
    ),
    titleControlsWrapper
  );
};

var renderToolbar = function renderToolbar(children) {
  return children ? _react2.default.createElement(
    'div',
    { className: 'private-header__toolbar' },
    children
  ) : null;
};

/**
 * Standard page title which allows CTAs, filters, etc.
 */
exports.default = _react2.default.createClass({
  displayName: 'UIHeader',

  propTypes: {
    alert: _react.PropTypes.node,
    breadcrumbs: _react.PropTypes.node,
    badge: _react.PropTypes.node,
    children: _react.PropTypes.node,
    className: _react.PropTypes.string,
    details: _react.PropTypes.node,
    flush: _react.PropTypes.bool.isRequired,
    fullWidth: _react.PropTypes.bool.isRequired,
    headingLevel: _react.PropTypes.oneOf(_HeadingConstants.HEADING_SIZES),
    role: _react.PropTypes.string,
    tabs: _react.PropTypes.node,
    title: _react.PropTypes.node,
    titleBadge: _react.PropTypes.node,
    titleControls: _react.PropTypes.node,
    use: _react.PropTypes.oneOf(Object.keys(USES))
  },

  getDefaultProps: function getDefaultProps() {
    return {
      flush: false, // for backwards compat, this will be true in next major version
      fullWidth: true,
      headingLevel: 'h1',
      role: 'banner'
    };
  },
  getInitialState: function getInitialState() {
    return {
      widthConstrained: false
    };
  },
  componentDidMount: function componentDidMount() {
    window.addEventListener('resize', this.handleWindowResize);
  },
  componentWillUnmount: function componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowResize);
  },
  handleWindowResize: function handleWindowResize() {
    this.testWidth();
  },
  headerRefCallback: function headerRefCallback(headerEl) {
    this._headerEl = headerEl;
    this.testWidth();
  },
  testWidth: function testWidth() {
    if (this._headerEl == null) {
      return;
    }
    // Measure width without the width-constrained class
    if (this.state.widthConstrained) {
      this._headerEl.classList.remove('private-header--width-constrained');
    }
    var titleEl = this._headerEl.querySelector('.private-header__title');
    if (titleEl == null) {
      return;
    }
    var widthConstrained = titleEl.clientWidth < CONSTRAINED_TITLE_WIDTH;
    if (this.state.widthConstrained) {
      this._headerEl.classList.add('private-header--width-constrained');
    }

    if (widthConstrained !== this.state.widthConstrained) {
      this.setState({ widthConstrained: widthConstrained });
    }
  },
  renderAlertContainer: function renderAlertContainer(alert) {
    return _react2.default.createElement(
      'div',
      { className: 'private-header__alert' },
      alert
    );
  },
  render: function render() {
    var _props = this.props,
        alert = _props.alert,
        badge = _props.badge,
        breadcrumbs = _props.breadcrumbs,
        children = _props.children,
        className = _props.className,
        details = _props.details,
        flush = _props.flush,
        fullWidth = _props.fullWidth,
        headingLevel = _props.headingLevel,
        role = _props.role,
        tabs = _props.tabs,
        title = _props.title,
        titleBadge = _props.titleBadge,
        titleControls = _props.titleControls,
        use = _props.use,
        rest = _objectWithoutProperties(_props, ['alert', 'badge', 'breadcrumbs', 'children', 'className', 'details', 'flush', 'fullWidth', 'headingLevel', 'role', 'tabs', 'title', 'titleBadge', 'titleControls', 'use']);

    var widthConstrained = this.state.widthConstrained;


    var classes = (0, _reactUtils.classNames)('private-header', className, {
      'private-header--with-breadcrumbs': breadcrumbs,
      'private-header--condensed': use === USES.condensed,
      'private-header--full-width': fullWidth,
      'private-header--flush': flush,
      'private-header--with-details': details,
      'private-header--with-tabs': tabs,
      'private-header--width-constrained': widthConstrained
    });

    if (titleBadge) {
      _devLogger2.default.warn({
        message: 'UIHeader: the `titleBadge` prop is deprecated and may be ' + 'removed in the future. Please use the `titleControls` prop instead.',
        key: 'UIHeader: use titleControls prop'
      });
    }

    return _react2.default.createElement(
      'header',
      _extends({
        className: classes,
        ref: this.headerRefCallback,
        role: 'presentation'
      }, rest),
      breadcrumbs != null ? breadcrumbs : null,
      _react2.default.createElement(
        'div',
        { className: 'private-header__inner', role: role },
        title ? renderHeading(badge, headingLevel, title, titleBadge, titleControls) : null,
        renderToolbar(children)
      ),
      details != null ? details : null,
      alert != null ? this.renderAlertContainer(alert) : null,
      tabs != null ? tabs : null
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1282/js/layout/UIHeader.js
// module id = 97
// module chunks = 0